import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import {
  Form,
  Grid,
  Popup,
  Icon,
  Modal,
  Header,
  Button,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { VENDORLINK_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import {
  CheckboxField,
  InputField,
  DropdownField,
} from 'Common/SemanticWrapper';
import { VendorLinkFieldEnum } from 'Common/Constants/SISIntegration';
import { makeOptionsDataWithEmpty } from 'Common/FormHelper';

export class VendorLinkConfigurationFormContainer extends Component {
  static propTypes = {
    leaIds: PropTypes.array,
    saveButtonDisabled: PropTypes.bool,
    leaIdModalOpen: PropTypes.bool,
    SetLeaIdModalOpen: PropTypes.func,
    submit: PropTypes.func.isRequired,
  };

  render() {
    const {
      leaIdModalOpen,
      setLeaIdModalOpen,
      leaIds,
      saveButtonDisabled,
      submit,
    } = this.props;

    const leaIdOptions = leaIds
      ? makeOptionsDataWithEmpty(
          leaIds.map(leaId => ({
            Id: leaId.RefId,
            Description: leaId.LocalId,
          }))
        )
      : [];

    return (
      <Form name={VENDORLINK_CONFIGURATION_FORM_NAME}>
        <TitledCard title="Configuration">
          <Grid>
            <Grid.Column width={9}>
              <Grid.Row>
                <label>
                  Enable VendorLink Nightly Import
                  <Popup
                    basic
                    trigger={
                      <Icon size="large" name="question circle outline" />
                    }
                    content={
                      <div>
                        You must run a "Manual Import" before the nightly auto
                        imports will run.
                      </div>
                    }
                  />
                  <Field
                    name={VendorLinkFieldEnum.Enabled}
                    component={CheckboxField}
                  />
                </label>
              </Grid.Row>

              <Grid.Row>
                <Field
                  component={InputField}
                  name={VendorLinkFieldEnum.BaseUrl}
                  label={'Base URL'}
                />
              </Grid.Row>

              <Grid.Row>
                <Field
                  component={InputField}
                  name={VendorLinkFieldEnum.VendorId}
                  label={'Vendor ID'}
                />
              </Grid.Row>

              <Grid.Row>
                <Field
                  component={InputField}
                  name={VendorLinkFieldEnum.VendorKey}
                  label={'Vendor Key'}
                />
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </TitledCard>

        <Modal
          open={leaIdModalOpen}
          onClose={() => setLeaIdModalOpen(false)}
          size="mini"
          closeIcon
        >
          <Header content="Select LEA Info Ref ID" icon="signup" />

          <Modal.Content className="p-t-0">
            <Modal.Description>
              <Field
                component={DropdownField}
                selection
                fluid
                name={VendorLinkFieldEnum.LEAInfoRefId}
                type="text"
                label="LEA Info Ref ID"
                options={leaIdOptions}
              />
            </Modal.Description>
          </Modal.Content>

          <Modal.Actions>
            <Button
              color="orange"
              size="big"
              content="Save"
              disabled={saveButtonDisabled}
              onClick={() => submit(VENDORLINK_CONFIGURATION_FORM_NAME)}
            />
          </Modal.Actions>
        </Modal>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  //make sure we have all the fields we need to connect
  const configOptions = [
    VendorLinkFieldEnum.BaseUrl,
    VendorLinkFieldEnum.VendorId,
    VendorLinkFieldEnum.VendorKey,
    VendorLinkFieldEnum.LEAInfoRefId,
  ];

  configOptions.forEach(name => {
    if (!values[name]) {
      errors[name] = 'Required';
    }
  });

  return errors;
};

export const VendorLinkConfigurationForm = reduxForm({
  form: VENDORLINK_CONFIGURATION_FORM_NAME,
  validate,
})(VendorLinkConfigurationFormContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkConfigurationStep/VendorLinkConfigurationForm.js